import { styled } from "styled-components";
import { motion } from "framer-motion";

export const Body = styled(motion.div)`
  display: flex;
  flex-direction: column;
  grid-column: 1 / 7;
  h3 {
    font-size: 1.5rem;
  }
  @media screen and (min-width: 1024px) {
    display: grid;
    grid-template-columns: 2fr 1fr;
    grid-column: 2 / 12;
    gap: 6rem;
  }
  @media screen and (min-width: 1600px) {
    grid-column: 3 / 11;
    gap: 7.5rem;
  }
`;

export const Article = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3rem;
  @media screen and (min-width: 1024px) {
    gap: 4rem;
  }
`;

export const Aside = styled(motion.div)`
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
  gap: 1.25rem;
  margin-top: 4rem;
  @media screen and (min-width: 768px) {
    width: 60%;
    margin-left: auto;
  }
  @media screen and (min-width: 1024px) {
    width: 100%;
  }
`;

export const ArticleSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  ol {
    font-size: 0.75rem;
  }
  ul,
  ol {
    margin-left: 1.625rem;
  }
  strong {
    ul,
    ol {
      margin-left: 1.625rem;
    }
  }
  h5 {
    font-weight: 700;
    font-size: 1rem;
    margin-bottom: 0.5rem;
  }
  a {
    color: var(--genseq-purple);
    text-decoration: underline;
    text-underline-position: under;
    text-decoration-thickness: 1px;
  }
  ul {
    li {
      margin-bottom: 0.5rem;
    }
  }

  strong {
    font-weight: 700;
  }

  .gatsby-image-wrapper {
    width: auto;
    height: 100%;
    max-width: 319px;
  }

  div {
    .gatsby-image-wrapper {
      width: 100%;
      height: auto;
      max-width: unset;
    }
  }
`;

export const Title = styled.h2`
  color: var(--genseq-purple);
  font-size: 1.875rem;
  font-weight: 400;
  margin-bottom: 1.5rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  svg {
    max-height: 24px;
  }
  @media screen and (min-width: 1024px) {
    font-size: 2.25rem;
  }
`;

export const BoxContainer = styled.div`
  background: #ffffff;
  border: 1px solid #e5e5e5;
  border-radius: 0.25rem;
  display: flex;
  gap: 0.75rem;
  flex-direction: column;
  position: relative;
  padding: 1rem 1.5rem;
  h5 {
    font-size: 1rem;
    margin-bottom: 0.5rem;
  }
  ul {
    margin-left: 0.75rem;
    li {
      margin-bottom: 0.5rem;
    }
  }
  @media screen and (min-width: 1024px) {
    margin-left: -1.25rem;
  }
`;

export const Images = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  position: relative;
  right: 0;
  img {
    box-shadow: 0px 12px 30px rgba(217, 217, 217, 0.7);
    height: auto;
    width: 100%;
  }
`;

export const TopImage = styled(motion.div)`
  grid-column: 4 / 7;
  grid-row-start: 0;
  grid-row-end: 1;
  z-index: 2;
  @media screen and (min-width: 1024px) {
    padding: 0;
    grid-column: 3 / 7;
  }
`;

export const MiddleImage = styled(motion.div)`
  grid-column: 2 / 5;
  grid-row-start: 0;
  grid-row-end: 1;
  margin-top: auto;
  margin-bottom: 3rem;
  margin-left: -3rem;
  padding-right: 3.125rem;
  z-index: 2;
  @media screen and (min-width: 1024px) {
    grid-column: 1 / 4;
    margin-bottom: -3rem;
    margin-right: -3rem;
    padding-right: 3.125rem;
  }
`;

export const BottomImage = styled(motion.div)`
  grid-column: 3 / 7;
  padding: 0.75rem 4rem;
  position: relative;
  top: -2rem;
  right: -1rem;
  z-index: 0;
  @media screen and (min-width: 1024px) {
    right: unset;
    left: 4rem;
    top: 0;
    grid-column: 2 / 6;
    padding: 0.75rem 2rem;
  }
`;

export const SVGBackground = styled.div`
  height: 100%;
  width: 100%;
  position: absolute;
  right: 0;
  svg {
    height: 50%;
    width: auto;
    right: 0;
    top: 50%;
    transform: translate(0, 50%);
  }
`;

export const Table = styled.div`
  span {
    background: #ffffff;
    border: 1px solid #e5e5e5;
    border-radius: 0.25rem;
    display: grid;
    grid-template-columns: 1fr 2fr;
    h5,
    p,
    div {
      padding: 0.875rem 1.25rem;
      ul {
        margin-left: 1rem;
      }
    }
    h5 {
      font-weight: 700;
      font-size: 1rem;
      &:nth-of-type(n + 2) {
        border-top: 1px solid #e5e5e5;
      }
    }
    p,
    div {
      font-weight: 300;
      border-left: 1px solid #e5e5e5;
      &:nth-of-type(n + 2) {
        border-top: 1px solid #e5e5e5;
      }
    }
    p {
      &:nth-of-type(n + 1) {
        border-top: ${({ combo }) => combo && "1px solid #e5e5e5"};
      }
    }
  }
  @media screen and (min-width: 1024px) {
    margin-left: -1.25rem;
  }
`;
